import { Divider } from "@mui/material";
import * as React from "react";

export function DividerDisplay(): JSX.Element {
  return <Divider variant="fullWidth" />;
}
